// Map pin anchors move while panning/zooming, so placement-mutating popper
// modifiers re-run on every frame and can loop until React bails out with #185.
export const MAP_PIN_POPPER_MODIFIERS = [
  { name: 'offset', options: { offset: [0, -10] } },
  { name: 'flip', enabled: false },
  { name: 'preventOverflow', enabled: false },
];

// States where access to Side/Community Listings is restricted to only active listings
export const ACTIVE_SIDE_LISTINGS_ONLY_STATES = new Set([
  'KY',
  'NC',
  'OR',
  'WA',
]);
